import cloneDeep from 'lodash/cloneDeep'
import unescape from 'lodash/unescape'
import { Blockchain } from '@/constants/blockchain'
import { ContractVersion } from '@/constants/contracts'
import { GigStatuses } from '@/constants/gig/gigStatuses'
import { JobStage } from '@/constants/job/jobStages'
import { JobStatus } from '@/constants/job/jobStatuses'
import { Statuses } from '@/constants/vacancies/statuses'

export default class NotificationListItem {
  id: number
  text: string
  event: string
  readed: boolean
  btnsLoaders: Array<boolean>
  gig_id: number | null
  gig_job_id: number | null
  job_id: number | null
  vacancy_id: number | null
  params: {
    winner?: 'Freelancer' | 'Customer' | 'Both'
    room_id?: string | null
    job_id?: string | null
    gig_id?: string | null
    slug?: string | null
    link?: string | null
    gig?: {
      id: number
      slug: string
      name: string
      status: GigStatuses
    } | null
    job?: {
      id: number
      slug: string
      name: string
      status: JobStatus
      stage: JobStage
      contract_version: ContractVersion
      blockchain: Blockchain
      txid?: string | null
      customer_id: number
      customer_wallet: number
      freelancer_id: number
      freelancer_wallet: string
    } | null
    vacancy?: {
      id: number
      slug: string
      status: Statuses
      name: string
    } | null
    review?: {
      id: number
    } | null
    // offer?: {
    //   id: number
    //   freelancer_id: number
    // }
  }

  constructor(data: Partial<NotificationListItem>) {
    Object.assign(
      this,
      cloneDeep({
        ...data,
        btnsLoaders: [false, false],
      })
    )
  }

  static fromServer(data: LX.NotificationListItem) {
    const text = unescape(data.text).replaceAll(/\u200B/g, '')
    const reviewParams = data.params?.review && !Array.isArray(data.params?.review) ? data.params.review : null
    let params = {}

    if (data.params) {
      const gigParams = data.params?.gig
      const jobParams = data.params?.job
      const vacancyParams = data.params?.vacancy
      let gig = null
      let job = null
      let vacancy = null
      const review = reviewParams ? { id: reviewParams.id } : null

      // Get actual stage from entity if available
      const entityGigJobStage = data.entity?.gig_job?.stage
      const entityJobStage = data.entity?.job?.stage
      const entityGigOfferStage = data.entity?.gig_offer?.stage

      if (gigParams) {
        gig = {
          id: gigParams.id,
          slug: gigParams.slug,
          name: gigParams.name,
          status: gigParams.status,
        }
      }
      if (jobParams) {
        // Use entity stage if available, otherwise fall back to params stage
        let actualStage
        if (entityGigJobStage) {
          actualStage = entityGigJobStage
        } else if (entityJobStage) {
          actualStage = entityJobStage
        } else {
          actualStage = jobParams.stage
        }

        job = {
          id: jobParams.id,
          slug: jobParams.slug,
          name: jobParams.name,
          status: jobParams.status,
          stage: actualStage,
          contract_version: jobParams.contract_version,
          blockchain: jobParams.blockchain,
          txid: jobParams.txid,
          customer_id: jobParams.customer_id,
          customer_wallet: jobParams.customer_wallet,
          freelancer_id: jobParams.freelancer_id,
          freelancer_wallet: jobParams.freelancer_wallet,
        }
      }

      if (vacancyParams) {
        vacancy = {
          id: vacancyParams.id,
          slug: vacancyParams.slug,
          status: vacancyParams.status,
          name: vacancyParams.name,
        }
      }

      params = {
        winner: data.params.winner,
        room_id: data.params.room_id,
        job_id: data.params.job_id,
        gig_id: data.params.gig_id,
        slug: data.params.slug,
        link: data.params.link,
        gig,
        job,
        vacancy,
        review,
      }
    }
    return new NotificationListItem({
      id: data.id,
      text,
      event: data.event,
      readed: data.read === 1,
      gig_id: data.gig_id,
      gig_job_id: data.gig_job_id,
      job_id: data.job_id,
      vacancy_id: data.vacancy_id,
      params,
    })
  }

  get byJob() {
    return !!this.job_id
  }

  get byGig() {
    return !!this.gig_id
  }

  get byVacancy() {
    return !!this.vacancy_id
  }
}
